import { IExternalCalendar } from "@app-types/websocket/externalCalender.types";

export const normalizeCalendarUrl = (value: string): string =>
  value.trim().replace(/^webcal:\/\//i, "https://");

export const isCalendarUrl = (value: string): boolean => {
  try {
    const url = new URL(normalizeCalendarUrl(value));
    return (url.protocol === "https:" || url.protocol === "http:") && !!url.hostname;
  } catch (_) {
    return false;
  }
};

// Subscription links can contain private tokens. Show only the host in summaries.
export const calendarSource = (value: string): string => {
  try {
    return new URL(normalizeCalendarUrl(value)).hostname;
  } catch (_) {
    return "";
  }
};

export const calendarViewers = (calendar: IExternalCalendar): number[] => {
  const ids = calendar.creator === undefined ? [] : [calendar.creator];
  return Array.from(new Set([...ids, ...(calendar.sharedWith || [])]));
};



// WEBPACK FOOTER //
// ./src/components/calendar2/externalCalendar/externalCalendar.utils.ts